import React from 'react';
import PropTypes from 'prop-types';

import { Dialog } from '@headlessui/react';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';
import { DrawerContext } from './Drawer';

/**
 * DrawerTitle component that serves to display the title in the Drawer.
 *
 * @component DrawerTitle
 * @param {Object} props - The properties for the DrawerTitle component.
 * @param {React.ReactNode} [props.children] - The child elements of the DrawerTitle.
 * @param {string} [props.className] - Optional additional CSS classes to apply to the DrawerTitle container.
 * @param {Object} [restProps] - Additional properties to be passed to the DrawerTitle container.
 * @returns {ReactElement} The rendered DrawerTitle component.
 * @example
 * <DrawerTitle>Title Here</DrawerTitle>
 */
export default function DrawerTitle({ children, className, ...restProps }) {
  useContext(DrawerContext, 'Drawer.Title must be a child of Drawer.');

  if (!children) return null;

  return (
    <Dialog.Title
      as="div"
      className={mergeClasses('', className)}
      {...restProps}
    >
      {children}
    </Dialog.Title>
  );
}

DrawerTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

DrawerTitle.defaultProps = {
  children: undefined,
  className: ''
};
